module.exports = "<div class=\"tag-cloud\">\n  <span class=\"tag\"\n    ng-repeat=\"tag in ::$ctrl.tags\">\n    {{::tag}}\n  </span>\n</div>\n";